<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<div class="project-control-item-component">
  <h2 mat-dialog-title style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Tenant: {{tenant.companyName}}</h2>
  <mat-dialog-content>
    <div class="tenant-form">
      <div style="display: flex; flex-direction: row; gap: 5px;">
        <mat-form-field class="example-full-width">
          <mat-label>Company Name</mat-label>
          <input matInput

                 name="companyName"
                 [(ngModel)]="tenant.companyName"
                 readonly
          >
        </mat-form-field>
        <mat-form-field class="example-full-width">
          <mat-label>Database Name</mat-label>
          <input matInput

                 name="databaseName"
                 [(ngModel)]="tenant.databaseName"
                 readonly
          >
        </mat-form-field>
      </div>
      <div style="display: flex; flex-direction: row;">
        <div style="flex:100%">
          <h3>Expiration</h3>
          <div style="display: flex; flex-direction: row;">
            <div style="flex:33%; height:58px;padding-top:10px">
              <mat-checkbox
                name="expires"
                [(ngModel)]="tenant.expires"
              >Expires
              </mat-checkbox>
            </div>
            <div style="flex:50%">
              <mat-form-field class="example-full-width" *ngIf="tenant.expires">
                <mat-label>Expiration Date</mat-label>
                <input matInput
                       [matDatepicker]="picker"

                       name="expirationDuration"
                       [(ngModel)]="tenant.expirationDate"
                >
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; flex-direction: row;">
        <div style="flex:100%">
          <h3>Features</h3>
          <div style="display: flex; flex-direction: row;">
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isTrainingEnabled"
                            [(ngModel)]="tenant.isTrainingEnabled">
                Awareness
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isAPIEnabled"
                            [(ngModel)]="tenant.isAPIEnabled">
                API
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isCloneEnabled"
                            [(ngModel)]="tenant.isCloneEnabled">
                Clone
              </mat-checkbox>
            </div>
          </div>
          <div style="display: flex; flex-direction: row;">
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isPracticeGuidanceEnabled"
                            [(ngModel)]="tenant.isPracticeGuidanceEnabled">
                Advisor Guidance
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isPolicyVersionEnabled"
                            [(ngModel)]="tenant.isPolicyVersionEnabled">
                Policy Version
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isPdfReportsEnabled"
                            [(ngModel)]="tenant.isPdfReportsEnabled">
                PDF Report
              </mat-checkbox>
            </div>
          </div>
          <div style="display: flex; flex-direction: row;">
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isLoggingEnabled"
                            [(ngModel)]="tenant.isLoggingEnabled">
                Logging
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isProjectsEnabled"
                            [(ngModel)]="tenant.isProjectsEnabled">
                Projects
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isControlsEnabled"
                            [(ngModel)]="tenant.isControlsEnabled">
                Controls
              </mat-checkbox>
            </div>
          </div>
          <div style="display: flex; flex-direction: row;">
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isAuditEnabled"
                            [(ngModel)]="tenant.isAuditEnabled">
                Audit
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isRisksEnabled"
                            [(ngModel)]="tenant.isRisksEnabled">
                RizkList
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isImplementationControlStatementsEnabled"
                            [(ngModel)]="tenant.isImplementationControlStatementsEnabled">
                Implementation Control Statements
              </mat-checkbox>
            </div>
          </div>
          <div style="display: flex; flex-direction: row;">
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isAzureAuthenticationEnabled"
                            [(ngModel)]="tenant.isAzureAuthenticationEnabled">
                Azure AD Authentication
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isOidcAuthenticationEnabled"
                            [(ngModel)]="tenant.isOidcAuthenticationEnabled">
                OIDC Authentication
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isWorkstreamsEnabled"
                            [(ngModel)]="tenant.isWorkstreamsEnabled">
                Workstreams
              </mat-checkbox>
            </div>
          </div>
          <div style="display: flex; flex-direction: row;">
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isOwnAmazonStorageEnabled"
                            [(ngModel)]="tenant.isOwnAmazonStorageEnabled">
                BYOS AWS S3
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="IsOwnAzureStorageEnabled"
                            [(ngModel)]="tenant.IsOwnAzureStorageEnabled">
                BYOS Azure Blob Storage
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isMappingTemplateEnabled"
                            [(ngModel)]="tenant.isMappingTemplateEnabled">
                Mapping Templates
              </mat-checkbox>
            </div>
          </div>
          <div style="display: flex; flex-direction: row;">
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isEditICSAndAPEnabled"
                            [(ngModel)]="tenant.isEditICSAndAPEnabled">
                Upload ICS-GAP Defaults
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isSecurityAssessmentTabnabled"
                            [(ngModel)]="tenant.isSecurityAssessmentTabEnabled">
                Security Assessment Tab
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isRiskAssessmentTabEnabled"
                            [(ngModel)]="tenant.isRiskAssessmentTabEnabled">
                Risk Assessment Tab
              </mat-checkbox>
            </div>
          </div>
          <div style="display: flex; flex-direction: row;">
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isRizkMapEnabled"
                            [(ngModel)]="tenant.isRizkMapEnabled">
                RizkMap
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isAWSMeteringEnabled"
                            [(ngModel)]="tenant.isAWSMeteringEnabled">
                AWS Metering
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isTrustBuilderEnabled"
                            [(ngModel)]="tenant.isTrustBuilderEnabled">
                Trust Builder
              </mat-checkbox>
            </div>

          </div>
          <div style="display: flex; flex-direction: row;">
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isElixirEnabled"
                            [(ngModel)]="tenant.isElixirEnabled">
                Elixir
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
              <mat-checkbox name="isSspEnabled"
                            [(ngModel)]="tenant.isSspEnabled">
                SSP Generation
              </mat-checkbox>
            </div>
            <div style="height:58px;padding-top:10px; flex:1 1 33%">
                <mat-checkbox name="isAutonomyEnabled"
                              [(ngModel)]="tenant.isAutonomyEnabled">
                  Fleet Mode
                </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; flex-direction: row;">
        <div style="flex:100%">
          <h3>Limits</h3>
          <div style="display: flex; flex-direction: row;">
            <div style="flex:1 1 20%; padding-right: 10px;">
              <mat-form-field class="example-full-width">
                <mat-label>Projects</mat-label>
                <input matInput

                       name="maxProjects"
                       [(ngModel)]="tenant.maxProjects"
                >
              </mat-form-field>
            </div>
            <div style="flex:1 1 20%">
              <mat-form-field class="example-full-width">
                <mat-label>Users</mat-label>
                <input matInput

                       name="maxUsers"
                       [(ngModel)]="tenant.maxUsers"
                >
              </mat-form-field>
            </div>
            <div style="flex:1 1 20%; padding-right: 10px;">
              <mat-form-field class="example-full-width">
                <mat-label>Awareness Users</mat-label>
                <input matInput

                       name="maxTrainingUsers"
                       [(ngModel)]="tenant.maxTrainingUsers"
                >
              </mat-form-field>
            </div>
            <div style="flex:1 1 20%; padding-right: 10px;">
              <mat-form-field class="example-full-width">
                <mat-label>Partner Users</mat-label>
                <input matInput

                       name="maxPartnerUsers"
                       [(ngModel)]="tenant.maxPartnerUsers"
                >
              </mat-form-field>
            </div>
            <div style="flex:1 1 20%; padding-right: 10px;">
              <mat-form-field class="example-full-width">
                <mat-label>Survey Users</mat-label>
                <input matInput

                       name="maxSurveyUsers"
                       [(ngModel)]="tenant.maxSurveyUsers"
                >
              </mat-form-field>
            </div>
            <div style="flex:1 1 20%; padding-right: 10px;">
              <mat-form-field class="example-full-width">
                <mat-label>Profiles</mat-label>
                <input matInput

                       name="maxProfiles"
                       [(ngModel)]="tenant.maxProfiles"
                >
              </mat-form-field>
            </div>
            <div style="flex:1 1 20%">
              <mat-form-field class="example-full-width">
                <mat-label>Surveys</mat-label>
                <input matInput

                       name="maxSurveys"
                       [(ngModel)]="tenant.maxSurveys"
                >
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; flex-direction: row;">
        <div style="flex:20%">
          <mat-form-field class="example-full-width">
            <mat-label>Advisor</mat-label>
            <input matInput

                   name="advisor"
                   [(ngModel)]="tenant.advisor"

            >
          </mat-form-field>
        </div>
        <div style="flex:20%">
          <mat-form-field class="example-full-width">
            <mat-label>MoAdvisory</mat-label>
            <input matInput

                   name="moAdvisory"
                   [(ngModel)]="tenant.moAdvisory"

            >
          </mat-form-field>
        </div>
        <div style="flex:20%">
          <mat-form-field class="example-full-width">
            <mat-label>Inactivity Timeout</mat-label>
            <input matInput

                   name="inactivityTimeout"
                   [(ngModel)]="tenant.inactivityTimeout"

            >
          </mat-form-field>
        </div>
      </div>
      <mat-tab-group>
        <mat-tab label="Frameworks">
          <p-table [value]="complianceAreas"
                   [paginator]="false"
                   [style]="{'margin-top':'10px'}"
                   [selectionMode]="'multiple'"
                   [(selection)]="selectedComplianceAreas"
          >
            <ng-template pTemplate="header">
              <tr style="white-space: nowrap; font-weight: bold;">
                <th style="width: 3em;">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>Name</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
              <tr>
                <td>
                  <p-tableCheckbox [value]="item"></p-tableCheckbox>
                </td>
                <td>
                  {{item.name}}</td>
              </tr>
            </ng-template>
          </p-table>

        </mat-tab>
        <mat-tab label="Policies & Procedures">
          <mat-checkbox name="includePolicyMappings" [(ngModel)]="tenant.includePolicyMappings">Include Mappings</mat-checkbox>
          <p-table [value]="policies" [(selection)]="selectedPolicies"
                   dataKey="id" selectionMode="multiple"
          >
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3em;">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>Name</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-expanded="expanded" let-i="rowIndex">
              <tr>
                <td>
                  <p-tableCheckbox [value]="item"></p-tableCheckbox>
                </td>
                <td>
                  {{item.name}}</td>
              </tr>
            </ng-template>
          </p-table>
        </mat-tab>
        <mat-tab label="The Vault">
          <mat-tab-group>
            <mat-tab label="Implementation Control Statements">
              <p-treeTable
                [value]="implementationControlStatementsTree"
                selectionMode="checkbox"
                [(selection)]="selectedTreeImplementationControlStatements"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 6em;">
                      <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
                    </th>
                    <th style="width: 20%;">Category</th>
                    <th>Name</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                  <tr>
                    <td>
                      <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                      <p-treeTableCheckbox [value]="rowNode"></p-treeTableCheckbox>
                    </td>
                    <td>{{rowData.category}}
                    </td>
                    <td>{{rowData.name}}</td>
                  </tr>
                </ng-template>
              </p-treeTable>
            </mat-tab>
            <mat-tab label="POAM">
              <p-treeTable
                [value]="actionPlanTemplatesTree"
                selectionMode="checkbox"
                [(selection)]="selectedTreeActionPlanTemplates"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 6em;">
                      <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
                    </th>
                    <th style="width: 20%;">Category</th>
                    <th>Name</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                  <tr>
                    <td>
                      <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                      <p-treeTableCheckbox [value]="rowNode"></p-treeTableCheckbox>
                    </td>
                    <td>{{rowData.category}}
                    </td>
                    <td>{{rowData.name}}</td>
                  </tr>
                </ng-template>
              </p-treeTable>
            </mat-tab>
            <mat-tab label="Reference Resources">
              <p-table [value]="referenceResources"
                       [paginator]="false"
                       [style]="{'margin-top':'10px'}"
                       [selectionMode]="'multiple'"
                       [(selection)]="selectedReferenceResources"
              >
                <ng-template pTemplate="header">
                  <tr style="white-space: nowrap; font-weight: bold;">
                    <th>Name</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item>
                  <tr>
                    <td>
                      <p-tableCheckbox [value]="item"></p-tableCheckbox>
                      {{item.name}}</td>
                  </tr>
                </ng-template>
              </p-table>

            </mat-tab>
            <mat-tab label="Recommended Solutions">
              <p-table [value]="recommendedSolutions"
                       [paginator]="false"
                       [style]="{'margin-top':'10px'}"
                       [selectionMode]="'multiple'"
                       [(selection)]="selectedRecommendedSolutions"
              >
                <ng-template pTemplate="header">
                  <tr style="white-space: nowrap; font-weight: bold;">
                    <th>Name</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item>
                  <tr>
                    <td>
                      <p-tableCheckbox [value]="item"></p-tableCheckbox>
                      {{item.name}}</td>
                  </tr>
                </ng-template>
              </p-table>

            </mat-tab>
          </mat-tab-group>
        </mat-tab>
        <mat-tab label="Profiles & Surveys">
          <p-table [value]="profiles"
                   [paginator]="false"
                   [style]="{'margin-top':'10px'}"
                   [selectionMode]="'multiple'"
                   [(selection)]="selectedProfiles"
          >
            <ng-template pTemplate="header">
              <tr style="white-space: nowrap; font-weight: bold;">
                <th style="width: 3em;">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>Profile Name</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
              <tr>
                <td>
                  <p-tableCheckbox [value]="item"></p-tableCheckbox>
                </td>
                <td>
                  {{item.name}}</td>
              </tr>
            </ng-template>
          </p-table>
          <p-table [value]="assessments"
                   [paginator]="false"
                   [style]="{'margin-top':'10px'}"
                   [selectionMode]="'multiple'"
                   [(selection)]="selectedAssessments"
          >
            <ng-template pTemplate="header">
              <tr style="white-space: nowrap; font-weight: bold;">
                <th style="width: 3em;">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>Survey Name</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
              <tr>
                <td>
                  <p-tableCheckbox [value]="item"></p-tableCheckbox>
                </td>
                <td>
                  {{item.quizData.name}}</td>
              </tr>
            </ng-template>
          </p-table>

        </mat-tab>

        <mat-tab label="Courses">
          <p-table [value]="trainings"
                   [paginator]="false"
                   [style]="{'margin-top':'10px'}"
                   [selectionMode]="'multiple'"
                   [(selection)]="selectedTrainings"
          >
            <ng-template pTemplate="header">
              <tr style="white-space: nowrap; font-weight: bold;">
                <th style="width: 3em;">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>Name</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
              <tr>
                <td>
                  <p-tableCheckbox [value]="item"></p-tableCheckbox>
                </td>
                <td>{{item.quizData.name}}</td>
              </tr>
            </ng-template>
          </p-table>

        </mat-tab>
        <mat-tab label="Audit">
          <p-table [value]="audits"
                   [paginator]="false"
                   [style]="{'margin-top':'10px'}"
                   [selectionMode]="'multiple'"
                   [(selection)]="selectedAudits"
          >
            <ng-template pTemplate="header">
              <tr style="white-space: nowrap; font-weight: bold;">
                <th style="width: 3em;">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>Name</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
              <tr>
                <td>
                  <p-tableCheckbox [value]="item"></p-tableCheckbox>
                </td>
                <td>{{item.name}}</td>
              </tr>
            </ng-template>
          </p-table>

        </mat-tab>

        <mat-tab label="Mapping Templates">
          <p-table [value]="mappingTemplates"
                   [paginator]="false"
                   [style]="{'margin-top':'10px'}"
                   [selectionMode]="'multiple'"
                   [(selection)]="selectedMappingTemplates"
          >
            <ng-template pTemplate="header">
              <tr style="white-space: nowrap; font-weight: bold;">
                <th style="width: 3em;">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>Name</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
              <tr>
                <td>
                  <p-tableCheckbox [value]="item"></p-tableCheckbox>
                </td>
                <td>{{item.name}}</td>
              </tr>
            </ng-template>
          </p-table>

        </mat-tab>

        <mat-tab label="Vendors">
          <p-treeTable
            [value]="dictionaryItemTree"
            selectionMode="checkbox"
            [(selection)]="selectedDictionaryItems"
          >
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 6em;">
                  <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
                </th>
                <th>Name</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
              <tr>
                <td>
                  <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                  <p-treeTableCheckbox [value]="rowNode"></p-treeTableCheckbox>
                </td>
                <td>{{rowData.name}}</td>
              </tr>
            </ng-template>
          </p-treeTable>

        </mat-tab>

        <mat-tab label="Document Request Groups">
          <p-table [value]="documentRequestGroups"
                   [paginator]="false"
                   [style]="{'margin-top':'10px'}"
                   [selectionMode]="'multiple'"
                   [(selection)]="selectedDocumentRequestGroups"
          >
            <ng-template pTemplate="header">
              <tr style="white-space: nowrap; font-weight: bold;">
                <th style="width: 3em;">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>Name</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
              <tr>
                <td>
                  <p-tableCheckbox [value]="item"></p-tableCheckbox>
                </td>
                <td>{{item.name}}</td>
              </tr>
            </ng-template>
          </p-table>

        </mat-tab>

        <mat-tab label="Workstreams">
          <p-table [value]="workstreams"
                   [paginator]="false"
                   [style]="{'margin-top':'10px'}"
                   [selectionMode]="'multiple'"
                   [(selection)]="selectedWorkstreams"
          >
            <ng-template pTemplate="header">
              <tr style="white-space: nowrap; font-weight: bold;">
                <th>Name</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
              <tr>
                <td>
                  <p-tableCheckbox [value]="item"></p-tableCheckbox>
                  {{item.name}}</td>
              </tr>
            </ng-template>
          </p-table>

        </mat-tab>
        <mat-tab label="OIDC" *ngIf="tenant.isOidcAuthenticationEnabled">
          <mat-checkbox class="example-margin"
                        [disabled]="!(tenant && tenant.isOidcAuthenticationEnabled)"
                        [(ngModel)]="tenant.enableOidc"
                        name="enableOidc">
            Enable OIDC Authentication
          </mat-checkbox>

          <div *ngIf="tenant.enableOidc && tenant && tenant.isOidcAuthenticationEnabled">Add {{oidcService.callbackUri(tenant.databaseName)}} to provider's allowed callback URLs</div>
          <div>
            <mat-form-field *ngIf="tenant.enableOidc && tenant && tenant.isOidcAuthenticationEnabled" style="min-width: 100%;">
              <mat-label>Authority</mat-label>
              <input matInput
                     [(ngModel)]="tenant.oidcAuthority" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field *ngIf="tenant.enableOidc && tenant && tenant.isOidcAuthenticationEnabled" style="min-width: 100%;">
              <mat-label>Config URL (if non-standard)</mat-label>
              <input matInput
                     [(ngModel)]="tenant.oidcConfigUrl" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field *ngIf="tenant.enableOidc && tenant && tenant.isOidcAuthenticationEnabled" style="min-width: 100%;">
              <mat-label>Client ID</mat-label>
              <input matInput
                     [(ngModel)]="tenant.oidcClientId" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field *ngIf="tenant.enableOidc && tenant && tenant.isOidcAuthenticationEnabled" style="min-width: 100%;">
              <mat-label>Client Secret</mat-label>
              <input matInput type="password"
                     [(ngModel)]="tenant.oidcClientSecret" />
            </mat-form-field>
          </div>
        </mat-tab>
        <mat-tab label="AWS" *ngIf="tenant.isAWSMeteringEnabled">
          <div style="width: 30%;">
            <mat-form-field style="width: 100%">
              <mat-label>Token</mat-label>
              <input matInput
                     [(ngModel)]="tenant.awsMarketplaceToken"
              >
            </mat-form-field>
            <button mat-raised-button (click)="getCustomer()">Get Customer Data</button>
          </div>
          <div style="width: 30%;">
            <mat-form-field style="width: 100%">
              <mat-label>Customer Identifier</mat-label>
              <input matInput
                     [(ngModel)]="tenant.awsMarketplaceCustomerIdentifier"
              >
            </mat-form-field>
          </div>
          <div style="width: 30%;">
            <mat-form-field style="width: 100%">
              <mat-label>Customer AWS Account ID</mat-label>
              <input matInput
                     [(ngModel)]="tenant.awsMarketplaceCustomerAccountId"
              >
            </mat-form-field>
          </div>
          <div style="width: 30%;padding-bottom: 30px;">
            <mat-form-field style="width: 100%">
              <mat-label>Product Code</mat-label>
              <input matInput
                     [(ngModel)]="tenant.awsMarketplaceProductCode"
              >
            </mat-form-field>
            <button mat-raised-button (click)="getEntitlements()">Get Entitlements</button>
            <b *ngIf="tenant.awsMarketplaceMaxProjects">
              Current max Projects: {{tenant.awsMarketplaceMaxProjects}}
            </b>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <alert></alert>
    <button mat-raised-button [disabled]="loading" style="border-radius: 6px;" (click)="onSave()">Save</button>
    <img *ngIf="loading"
         src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
    <button mat-raised-button (click)="onClose()">Cancel</button>
  </mat-dialog-actions>
</div>
